import CodeTestCase from './code-test-case'

export default CodeTestCase
